module.exports = __webpack_public_path__ + "static/media/product19.2836887d.jpg";